import { Col, Container, Nav, Row } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { useParams, Outlet } from "react-router-dom";
import allControls from "./controls.json";

function Family() {
  let { familyId } = useParams();
  let family = allControls.find((c) => c.Family === familyId);

  return (
    <Container>
      <Row>
        <Col sm={3}>
          <Nav variant="pills" className="flex-column">
            {family.Controls.map((control) => {
              return (
                <Nav.Item key={control["Control Identifier"]}>
                  <LinkContainer
                    to={`/${familyId}/${control["Control Identifier"]}`}
                  >
                    <Nav.Link>{control["Control Identifier"]}</Nav.Link>
                  </LinkContainer>
                </Nav.Item>
              );
            })}
          </Nav>
        </Col>
        <Col sm={9}>
          <Outlet />
        </Col>
      </Row>
    </Container>
  );
}

export default Family;
